import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import GoToProcessorPickerButton from 'payments-enrollment-embed-lib/buttons/GoToProcessorPickerButton';
import { useScopes } from 'growth-payments-core/auth/scopes';
import { PAYMENT_LINKS_WRITE } from '../../../constants/scopes';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import { PaymentLinksURL } from '../../../utils/paymentUrls';
import ModalWrapper from '../ModalWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreateAPaymentLinkModalState = {
  PRE_ENROLL: 'preEnroll',
  POST_ENROLL: 'postEnroll'
};
const CreateAPaymentLinkModal = ({
  handleInterstitialModalClose,
  screen,
  modalState
}) => {
  const scopes = useScopes();
  const hasPaymentLinksWrite = scopes.has(PAYMENT_LINKS_WRITE);
  const Body = /*#__PURE__*/_jsxs(View, {
    as: "div",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "300",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.createAPaymentLinkModal.createAndAddPaymentLink.paragraph1"
      })
    }), /*#__PURE__*/_jsx(List, {
      styled: true,
      children: [1, 2].map(bulletPoint => /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `embedPoints.createAPaymentLinkModal.createAndAddPaymentLink.bullets.bullet${bulletPoint}`
          })
        })
      }, bulletPoint))
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockStart: "500",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `embedPoints.createAPaymentLinkModal.createAndAddPaymentLink.paragraph2.${modalState}`
      })
    })]
  });
  const CreatePaymentLinkButton = ({
    block = false
  }) => /*#__PURE__*/_jsx(Button, {
    "data-test-id": "createTestPaymentLinkButton",
    use: "primary",
    rel: "noopener" // override the rel attribute to remove the "noreferrer" tag, slack ref - https://hubspot.slack.com/archives/CEZNHE030/p1696003611704799
    ,
    disabled: !hasPaymentLinksWrite,
    external: true,
    href: PaymentLinksURL,
    block: block,
    onClick: () => track(events.paymentsInterstitialModalInteraction, {
      action: 'click',
      screen,
      value: 'createPaymentLink'
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.ctas.createPaymentLink"
    })
  });
  const Footer = modalState === CreateAPaymentLinkModalState.PRE_ENROLL ? /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(CreatePaymentLinkButton, {
      block: false
    }), /*#__PURE__*/_jsx(GoToProcessorPickerButton, {
      use: "secondary",
      external: true,
      openInCommerceHome: true,
      sourceApp: screen,
      location: "embed-point-pre-enroll-modal"
    })]
  }) : /*#__PURE__*/_jsx(CreatePaymentLinkButton, {
    block: true
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    Body: Body,
    Footer: Footer,
    modalSubTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.createAPaymentLinkModal.createAPaymentLink"
    }),
    onClose: handleInterstitialModalClose,
    modalName: "createAPaymentLinkModal",
    illustrationName: "payments-button",
    paddingBlock: "1000",
    paddingInlineEnd: "1000"
  });
};
export default CreateAPaymentLinkModal;